import Cryptcha from "cryptcha"
import { writable } from "svelte/store"

export const cryptchaSolution = writable("")
export const cryptchaSolutionId = writable("")
export const cryptchaStep = writable({
    currentStep: -1,
    stepsCount: -1,
    solved: false,
    correct: false,
    error: false,
    waitingForInit: -1,
})

let cryptcha
let cryptchaTarget
export async function initCryptcha(siteId: string) {
    if (!cryptcha) {
        // create new instance
        cryptchaTarget = document.createElement("div")
        cryptcha = new Cryptcha({
            siteId: siteId,
            target: null,
            baseUrl: "https://cryptcha.webmakers.de/api/command",
            log: false,
            autoSolve: true,
            onSolved({ solution, solutionId }) {
                cryptchaSolution.set(solution)
                cryptchaSolutionId.set(solutionId)
            },
            onUpdate(_) {
                cryptchaStep.set(_)
            },
        })
    }
}

export function resetCryptcha() {
    cryptcha = null
    cryptchaSolution.set("")
    cryptchaSolutionId.set("")
}
